module.exports = ".alert{\n\tposition: absolute;\n    top: 40%;\n    left: 10%;\n    right: 10%;\n    margin-left: auto;\n    margin-right: auto;\n}"